import { ICharacterLevel } from '../../mechanics/characters/Character'
import "./LevelBar.scss"

interface ILevelBarProps {
  level: ICharacterLevel
}

export default function LevelBar({ level }: ILevelBarProps) {
  const widthHpBar = Math.round((level.currentExperience / level.experianceToLevelUp) * 100)

  return (
    <div className="levelbar">
      <span>{level.curruntLevel}</span>
      <div className="levelbar__bar">
        <div className="levelbar__bar-done" style={{ width: `${widthHpBar}%` }}>
        </div>
        <span className="levelbar__text">{level.currentExperience}/{level.experianceToLevelUp} exp</span>
      </div>
      <span>{level.curruntLevel + 1}</span>
    </div>
  )
}
